/* =====================================================================
   DKHL — HEADER SEARCH  (v19 — დესკტოპი + ტელეფონი)
   v19: ტელეფონზე/ტაბლეტზე X ინფუთს ასუფთავებს (დესკტოპზე — ისევ ხურავს).
        1199–1360px-ზე ინფუთი "ძებნა"-ს ტექსტს სრულად ფარავს (ბოლო ასო აღარ ჩანს).
   v18: ტექსტის წაშლისას თეგები/პროდუქტები მაშინვე ბრუნდება (დაყოვნების გარეშე).
   v17: ცოცხალი ძებნა სწრაფია — სერვერი მხოლოდ პირველ 5 პროდუქტს ხატავს,
        დანარჩენებზე მხოლოდ რიცხვს აბრუნებს; პრემიუმ skeleton; 1 swatch — იმალება.
   v16: ცოცხალი ძებნა — წერისას შედეგები პანელშივე ჩნდება (Enter-მდე).
        ქართულად და ინგლისურად; /en/-ს საერთოდ არ იყენებს.
   v15: ტელეფონზე ჰედერი უცვლელია — პანელი ჩამოდის და ინფუთი პანელის
        თავშია, "ხშირად ეძებენ"-ის ზემოთ.
   v13: ტელეფონზე თეგები და პროდუქტები 2 სვეტად.
   v12: ტელეფონზე/ტაბლეტზე (<1100px) იგივე ძებნა: ჰამბურგერი და აიქონები
        ქრება, ინფუთი ლოგოდან ჰედერის ბოლომდე, პანელი ჰედერის სიგანის,
        კლავიატურა მაშინვე იხსნება, გვერდი არ სქროლავს.
   v10: ქვემოთ კონკრეტული პროდუქტები (SKU-ით); მენიუს და Search გვერდის ბაგები.
   v8: ფონის ბლარი მენიუსავით; პროდუქტები თემის ბარათებით
       (საჭიროა sections/dkhl-search-products.liquid).
   v7: ინფუთის ქვემოთ ჩამოსაშლელი — ხშირად მოძებნილი + 5 პროდუქტი.
   v5: თემის ენის (KA/EN) და ძებნის ელემენტებს კოდი საერთოდ აღარ ეხება —
   მხოლოდ CSS მალავს მათ. ატრიბუტებს/inert-ს აღარ ვცვლით.
   ძებნის ღილაკი დესკტოპზე აღარ ხსნის ძველ ჩამოსაშლელს —
   ამის ნაცვლად ჰედერშივე ჩნდება ინფუთი.
   ===================================================================== */
;(() => {
  'use strict'

  /* ---------- პარამეტრები ---------- */
  const DESKTOP = window.matchMedia('(min-width: 1100px)')
  const isDesktop = () => DESKTOP.matches
  const LOGO_PULL = 40 // px — დესკტოპზე რამდენით შევიდეს ლოგო ჰედერის შიდა დაშორებაში
  const LOGO_MIN_EDGE = 16 // px — ჰედერის კიდიდან მინიმალური დაშორება
  const GAP_AFTER_LOGO = 24 // px — D ლოგოსა და ინფუთს შორის (დესკტოპი)
  const GAP_BEFORE_ICONS = 12 // px — ინფუთსა და ანგარიშის აიქონს შორის (დესკტოპი)
  const SEARCH_COVER = 6 // px — ინფუთი "ძებნა"-ს ტექსტს ამდენით მეტად ფარავს
  const TYPE_DELAY = 620 // ms — როდის დაიწყოს placeholder-ის წერა
  const TYPE_DELAY_MOBILE = 380 // ms — იგივე ტელეფონზე
  const TYPE_SPEED = 26 // ms — ერთი ასოს სიჩქარე (ნაკლები = უფრო სწრაფი)

  /* ---------- ჩამოსაშლელი (ინფუთის ქვემოთ) ---------- */
  // ხშირად მოძებნილი — შეცვალე/დაამატე როგორც გინდა
  const POPULAR_TAGS = [
    'iPhone 18 Pro Max',
    'Galaxy S26 Ultra',
    'iPhone Duo',
    'Pixel 11 Pro',
  ]
  // ქვემოთ ნაჩვენები პროდუქტები — SKU (ან handle), ამავე რიგით
  const PRODUCT_CODES = ['SPI00326', 'SPI00362', 'SPG0198', 'SGZ002', 'SW0013']
  // თუ ვერცერთი მოიძებნა — ამ კოლექციიდან აიღებს:
  const PRODUCTS_COLLECTION = 'all'
  const PRODUCTS_LIMIT = 5 // სექციაშიც limit: 5 წერია
  const PRODUCTS_SECTION = 'dkhl-search-products' // sections/dkhl-search-products.liquid
  const PRODUCTS_CACHE_MIN = 10 // წუთი — რამდენ ხანს დაიმახსოვროს ბრაუზერმა
  const LIVE_MIN_CHARS = 2 // რამდენი ასოდან დაიწყოს ცოცხალი ძებნა
  const LIVE_DEBOUNCE = 260 // ms — წერის დასრულებიდან რამდენში გაიგზავნოს
  const LIVE_LIMIT_DESKTOP = 5 // შედეგები დესკტოპზე (1 რიგი)
  const LIVE_LIMIT_MOBILE = 4 // შედეგები ტელეფონზე/ტაბლეტზე (2×2 / 1 რიგი)
  const CARDS_DELAY = 1.2 // s — როდის იწყებს პროდუქტები გამოჩენას
  const CARDS_DELAY_MOBILE = 0.34 // s — იგივე ტელეფონზე (CSS-ს ემთხვევა)
  const cardsDelay = () => (isDesktop() ? CARDS_DELAY : CARDS_DELAY_MOBILE)

  const OPEN = 'is-dkhl-search-open'
  const FADE_SEL = '.header__localization, .header__scheme' // მხოლოდ გაზომვისთვის
  const BTN_SEL = '.header__search summary, .header__icon--search'
  const LOGO_SEL = '.header__heading, .header__heading-link'

  const isKa = (document.documentElement.lang || 'ka').toLowerCase().startsWith('ka')
  const TEXT = isKa
    ? {
        placeholder: 'რისი მოძებნა გსურთ?',
        submit: 'ძებნა',
        close: 'დახურვა',
        clear: 'გასუფთავება',
        tags: 'ხშირად ეძებენ',
        products: 'პოპულარული პროდუქტები',
        results: 'შედეგები',
        all: 'ყველა შედეგი',
        empty: (q) => `„${q}“ — ვერაფერი მოიძებნა`,
        emptyHint: 'სცადე სხვა სიტყვა ან მოდელის სახელი',
      }
    : {
        placeholder: 'What are you looking for?',
        submit: 'Search',
        close: 'Close',
        clear: 'Clear',
        tags: 'Popular searches',
        products: 'Popular products',
        results: 'Results',
        all: 'All results',
        empty: (q) => `No results for “${q}”`,
        emptyHint: 'Try another word or a model name',
      }

  const esc = (v) =>
    String(v == null ? '' : v).replace(/[&<>"']/g, (c) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
    })[c])

  const ICON_SEARCH =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>'
  const ICON_ARROW =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>'
  const ICON_CLOSE =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>'

  /* ---------- დამხმარეები ---------- */
  const inDrawer = (el) =>
    !!el.closest('header-drawer, menu-drawer, .menu-drawer, #menu-drawer')
  const isVisible = (el) => {
    const r = el.getBoundingClientRect()
    return r.width > 0 && r.height > 0
  }
  const pick = (root, sel) =>
    Array.from(root.querySelectorAll(sel)).find(
      (el) => !inDrawer(el) && isVisible(el)
    ) || null

  const getHeader = () =>
    document.querySelector(
      '#shopify-section-header .header, .shopify-section-header .header'
    )

  // offset-ებს transform არ ცვლის → ანიმაციის შუაშიც ზუსტია
  function offsetWithin(el, root, prop) {
    let v = 0
    let node = el
    while (node && node !== root) {
      v += node[prop]
      node = node.offsetParent
    }
    if (node === root) return v
    const a = el.getBoundingClientRect()
    const b = root.getBoundingClientRect()
    return prop === 'offsetLeft'
      ? a.left - b.left - root.clientLeft
      : a.top - b.top - root.clientTop
  }
  const leftWithin = (el, root) => offsetWithin(el, root, 'offsetLeft')
  const topWithin = (el, root) => offsetWithin(el, root, 'offsetTop')

  const typing = new WeakMap()

  /* ================= ერთჯერადი მომზადება ================= */

  function setup(header) {
    if (!header || header.dataset.dkhlHs === '1') return !!header

    header.dataset.dkhlHs = '1'
    header.classList.add('dkhl-hs')
    markLogo(header)

    // მენიუ: --dkhl-i = მარცხნიდან, --dkhl-r = მარჯვნიდან
    const items = header.querySelectorAll(
      '.header__inline-menu .list-menu--inline > li'
    )
    items.forEach((li, i) => {
      li.style.setProperty('--dkhl-i', i)
      li.style.setProperty('--dkhl-r', items.length - 1 - i)
    })

    // ძებნის ბმული — ყოველთვის მიმდინარე ენის (KA → /search, EN → /en/search)
    const themeForm = header.querySelector('.header__search form')
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'

    const form = document.createElement('form')
    form.className = 'dkhl-hs-box'
    form.method = 'get'
    form.setAttribute('role', 'search')
    form.action = root + 'search'

    form.innerHTML = `
      <div class="dkhl-hs-box__clip">
        <div class="dkhl-hs-box__field">
          <input class="dkhl-hs-box__input" type="search" name="q"
                 autocomplete="off" autocorrect="off" autocapitalize="off"
                 spellcheck="false" enterkeyhint="search" tabindex="-1">
          <button class="dkhl-hs-box__close" type="button" tabindex="-1">${ICON_CLOSE}</button>
        </div>
      </div>
      <button class="dkhl-hs-box__submit" type="submit" tabindex="-1">
        <span class="dkhl-hs-box__submit-bg"></span>${ICON_SEARCH}
      </button>`

    const input = form.querySelector('input')
    input.setAttribute('aria-label', TEXT.placeholder)
    form.querySelector('.dkhl-hs-box__submit').setAttribute('aria-label', TEXT.submit)

    if (themeForm) {
      // მხოლოდ ძებნის პარამეტრები — ენასთან დაკავშირებულს არაფერს ვიღებთ
      themeForm.querySelectorAll('input[type="hidden"]').forEach((h) => {
        if (!/^(type|options\[.+\])$/.test(h.name)) return
        const c = h.cloneNode()
        c.removeAttribute('id')
        form.appendChild(c)
      })
    }

    input.addEventListener('input', () => liveSearch(header))

    form.addEventListener('submit', (e) => {
      if (!input.value.trim()) {
        e.preventDefault()
        input.focus()
      }
    })

    // X: დესკტოპზე — დახურვა, ტელეფონზე/ტაბლეტზე — ტექსტის გასუფთავება
    const closeBtn = form.querySelector('.dkhl-hs-box__close')
    closeBtn.addEventListener('click', () => {
      if (isDesktop()) close(header, true)
      else clearInput(header)
    })
    // ტელეფონზე დაჭერისას ინფუთი ფოკუსს არ კარგავს → კლავიატურა არ "ხტება"
    closeBtn.addEventListener('mousedown', (e) => {
      if (!isDesktop()) e.preventDefault()
    })

    header.appendChild(form)
    header.appendChild(buildPanel(form, root))
    placeForm(header)

    if ('ResizeObserver' in window) {
      new ResizeObserver(() => {
        if (header.classList.contains(OPEN)) measure(header)
      }).observe(header)
    }
    return true
  }

  /* ინფუთის ადგილი: დესკტოპზე — ჰედერში (მორფი), ტელეფონზე — პანელის თავში */
  function placeForm(header) {
    const form = header.querySelector('.dkhl-hs-box')
    const panel = header.querySelector('.dkhl-hs-panel')
    if (!form || !panel) return
    if (isDesktop()) {
      if (form.parentElement !== header) header.insertBefore(form, panel)
    } else {
      const slot = panel.querySelector('.dkhl-hs-panel__search')
      if (slot && form.parentElement !== slot) slot.appendChild(form)
    }
    // X-ის სახელი ეკრანის მიხედვით
    const x = form.querySelector('.dkhl-hs-box__close')
    if (x) x.setAttribute('aria-label', isDesktop() ? TEXT.close : TEXT.clear)
  }

  /* ================= პოზიციების გამოთვლა ================= */

  // ხილული ლოგო (დესკტოპზე და ტელეფონზე შეიძლება სხვადასხვა იყოს)
  function markLogo(header) {
    const logo = pick(header, LOGO_SEL)
    header.querySelectorAll('.dkhl-hs-logo').forEach((el) => {
      if (el !== logo) el.classList.remove('dkhl-hs-logo')
    })
    if (logo) logo.classList.add('dkhl-hs-logo')
    return logo
  }

  function measure(header) {
    const form = header.querySelector('.dkhl-hs-box')
    if (!form) return
    const desktop = isDesktop()

    // ტელეფონი: ჰედერში არაფერი მოძრაობს, ინფუთი პანელშია
    if (!desktop) {
      ;['--dkhl-logo-x', '--dkhl-tile-x', '--dkhl-tile-y', '--dkhl-field-x'].forEach((v) =>
        header.style.setProperty(v, '0px')
      )
      measurePanel(header)
      return
    }

    const logo = markLogo(header) // ლოგო არაა აუცილებელი

    const cs = getComputedStyle(header)
    const padL = parseFloat(cs.paddingLeft) || 0
    const padR = parseFloat(cs.paddingRight) || 0

    // 1) ლოგო — მარცხენა კიდისკენ (დესკტოპზე ჰედერის შიდა დაშორებაშიც შედის)
    const logoTarget = Math.max(LOGO_MIN_EDGE, padL - LOGO_PULL)
    const scale = 1
    let shift = 0
    let boxLeft = padL
    if (logo) {
      shift = Math.min(0, logoTarget - leftWithin(logo, header))
      boxLeft = logoTarget + logo.offsetWidth * scale + GAP_AFTER_LOGO
    }
    header.style.setProperty('--dkhl-logo-s', String(scale))

    // 2) ინფუთი მთავრდება დარჩენილ აიქონებამდე (ანგარიში, კალათა)
    let iconsLeft = header.clientWidth - padR
    const icons = pick(header, '.header__icons')
    if (icons) {
      const kids = Array.from(icons.children).filter(
        (k) =>
          isVisible(k) &&
          !k.matches(FADE_SEL + ', .header__search') &&
          !k.querySelector(FADE_SEL + ', .header__search')
      )
      if (kids.length) {
        iconsLeft = Math.min(...kids.map((k) => leftWithin(k, header)))
      }
    }

    // ინფუთის მარჯვენა კიდე — აიქონებამდე GAP-ით, მაგრამ "ძებნა"-ს ღილაკს
    // (ტექსტიანად) ყოველთვის სრულად ფარავს. ვიწრო დესკტოპზე (≈1199–1360px)
    // აიქონებს შორის დაშორება GAP-ზე ნაკლებია და ბოლო ასო გარეთ რჩებოდა.
    let boxEnd = iconsLeft - (icons ? GAP_BEFORE_ICONS : 0)
    const triggers = Array.from(
      header.querySelectorAll(BTN_SEL + ', .header__search .header__icon-name')
    ).filter((el) => !inDrawer(el) && isVisible(el))
    const parts = triggers
      .flatMap((el) => [el, ...el.querySelectorAll('*')])
      .filter((el) => el instanceof HTMLElement && el.offsetWidth > 0)
    if (parts.length) {
      const triggerEnd = Math.max(
        ...parts.map((el) => leftWithin(el, header) + Math.max(el.offsetWidth, el.scrollWidth))
      )
      boxEnd = Math.max(boxEnd, Math.min(triggerEnd + SEARCH_COVER, iconsLeft - 2))
    }
    const boxRight = header.clientWidth - boxEnd

    header.style.setProperty('--dkhl-logo-x', `${shift}px`)
    header.style.setProperty('--dkhl-box-l', `${boxLeft}px`)
    header.style.setProperty('--dkhl-box-r', `${boxRight}px`)

    // 3) მუქი ღილაკი (მარცხნივ) იწყებს "ძებნა"-ს აიქონის ადგილიდან
    const tile = form.querySelector('.dkhl-hs-box__submit')
    const btnIcon = pick(header, '.header__search summary svg, .header__icon--search svg')
    if (tile && btnIcon) {
      const hr = header.getBoundingClientRect()
      const ir = btnIcon.getBoundingClientRect()
      const iconX = ir.left + ir.width / 2 - hr.left - header.clientLeft
      const iconY = ir.top + ir.height / 2 - hr.top - header.clientTop
      const tileX = leftWithin(tile, header) + tile.offsetWidth / 2
      const tileY = topWithin(tile, header) + tile.offsetHeight / 2
      const dx = Math.max(0, iconX - tileX)
      header.style.setProperty('--dkhl-tile-x', `${dx}px`)
      header.style.setProperty('--dkhl-tile-y', `${iconY - tileY}px`)
      // ველის მარცხენა ბოლო იმავე წერტილიდან იწყებს → ღილაკი კიდეზე "ზის"
      header.style.setProperty('--dkhl-field-x', `${dx}px`)
    }

    measurePanel(header)
  }

  // პანელის მაქსიმალური სიმაღლე = ხილული ეკრანი (კლავიატურის გათვალისწინებით)
  function measurePanel(header) {
    const panel = header.querySelector('.dkhl-hs-panel')
    if (!panel) return
    const vh = window.visualViewport ? window.visualViewport.height : window.innerHeight
    const top = header.getBoundingClientRect().top + header.clientTop + panel.offsetTop
    header.style.setProperty('--dkhl-vh', `${Math.round(vh)}px`)
    header.style.setProperty('--dkhl-panel-top', `${Math.round(top)}px`)
  }

  /* ================= placeholder — typing ================= */

  function startTyping(header, input) {
    stopTyping(header)
    input.placeholder = ''
    const chars = Array.from(TEXT.placeholder)
    const state = { i: 0, t: 0 }
    const step = () => {
      state.i += 1
      input.placeholder = chars.slice(0, state.i).join('')
      if (state.i < chars.length) {
        state.t = setTimeout(step, TYPE_SPEED + Math.random() * 18)
      }
    }
    state.t = setTimeout(step, isDesktop() ? TYPE_DELAY : TYPE_DELAY_MOBILE)
    typing.set(header, state)
  }

  function stopTyping(header) {
    const state = typing.get(header)
    if (state) clearTimeout(state.t)
  }

  /* ================= ჩამოსაშლელი ================= */

  function buildPanel(form, root) {
    const input = form.querySelector('input')
    const panel = document.createElement('div')
    panel.className = 'dkhl-hs-panel'
    panel.setAttribute('aria-hidden', 'true')

    panel.innerHTML = `
      <div class="dkhl-hs-panel__search"></div>
      <div class="dkhl-hs-panel__body">
        <div class="dkhl-hs-panel__default">
          <p class="dkhl-hs-panel__title">${esc(TEXT.tags)}</p>
          <div class="dkhl-hs-panel__tags">
            ${POPULAR_TAGS.map((t, i) => `
              <button type="button" class="dkhl-hs-tag" style="--dkhl-k:${i}" data-q="${esc(t)}">${esc(t)}</button>`).join('')}
          </div>
          <div class="dkhl-hs-panel__products-wrap">
            <p class="dkhl-hs-panel__title dkhl-hs-panel__title--products">${esc(TEXT.products)}</p>
            <div class="dkhl-hs-panel__products">
              ${skeletonHtml(PRODUCTS_LIMIT)}
            </div>
          </div>
        </div>
        <div class="dkhl-hs-panel__results" aria-live="polite">
          <div class="dkhl-hs-results__head">
            <p class="dkhl-hs-panel__title dkhl-hs-results__title">${esc(TEXT.results)}</p>
            <button type="button" class="dkhl-hs-results__all" hidden>
              <span class="dkhl-hs-results__all-text"></span>${ICON_ARROW}
            </button>
          </div>
          <div class="dkhl-hs-results__grid"></div>
          <div class="dkhl-hs-results__empty" hidden>
            <p class="dkhl-hs-results__empty-title"></p>
            <p class="dkhl-hs-results__empty-hint">${esc(TEXT.emptyHint)}</p>
          </div>
        </div>
      </div>`

    panel.addEventListener('click', (e) => {
      // თეგზე დაჭერა → სიტყვა ინფუთში + შედეგები აქვე
      const tag = e.target.closest('.dkhl-hs-tag')
      if (tag) {
        input.value = tag.dataset.q
        liveSearch(panel.closest('.header'), true)
        try {
          input.focus({ preventScroll: true })
        } catch (err) {}
        return
      }
      // "ყველა შედეგი" → ძებნის გვერდი
      if (e.target.closest('.dkhl-hs-results__all')) {
        form.requestSubmit ? form.requestSubmit() : form.submit()
      }
    })

    panel.dataset.root = root
    return panel
  }

  /* პროდუქტები — თემის ბარათებით (product-card-simple), Shopify-ს
     Section Rendering API-თ: /collections/<handle>?section_id=dkhl-search-products */

  const cacheKey = (root) =>
    `dkhl-hs-products:${root}:${PRODUCT_CODES.join('|')}:${PRODUCTS_COLLECTION}`

  function readCache(root) {
    try {
      const raw = sessionStorage.getItem(cacheKey(root))
      if (!raw) return null
      const { t, html } = JSON.parse(raw)
      return Date.now() - t < PRODUCTS_CACHE_MIN * 60000 ? html : null
    } catch (e) {
      return null
    }
  }

  function writeCache(root, html) {
    try {
      sessionStorage.setItem(cacheKey(root), JSON.stringify({ t: Date.now(), html }))
    } catch (e) {}
  }

  // ერთი მოთხოვნა → სექციის ბარათები (li) + თემის სტილები
  function fetchCards(url) {
    return fetch(url)
      .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html')
        const el = doc.getElementById(`shopify-section-${PRODUCTS_SECTION}`) || doc.body
        return {
          styles: Array.from(el.querySelectorAll('link[rel="stylesheet"]')),
          cards: Array.from(el.querySelectorAll('li.dkhl-hs-card')),
        }
      })
      .catch(() => ({ styles: [], cards: [] }))
  }

  const tagUrl = (root, q) =>
    `${root}search?q=${encodeURIComponent(q)}&type=product` +
    `&options%5Bprefix%5D=last&section_id=${PRODUCTS_SECTION}`

  const collectionUrl = (root) =>
    `${root}collections/${PRODUCTS_COLLECTION}?section_id=${PRODUCTS_SECTION}`

  // ძებნის შედეგებიდან ზუსტად ის პროდუქტი, რომლის SKU/handle ემთხვევა
  function pickCard(cards, code) {
    const c = code.trim().toLowerCase()
    return (
      cards.find((li) =>
        (li.dataset.skus || '').toLowerCase().split(/\s+/).includes(c)
      ) ||
      cards.find((li) => (li.dataset.handle || '').toLowerCase() === c) ||
      (cards.length === 1 ? cards[0] : null)
    )
  }

  function buildHtml(styles, cards) {
    if (!cards.length) return ''
    const seenHref = new Set()
    const css = styles
      .filter((l) => !seenHref.has(l.href) && seenHref.add(l.href))
      .map((l) => l.outerHTML)
      .join('')
    cards.forEach((li, i) => li.style.setProperty('--dkhl-k', i))
    return (
      css +
      '<ul class="predictive-search__results-list predictive-search__results-list_products list-unstyled active dkhl-hs-products" role="list">' +
      cards.map((li) => li.outerHTML).join('') +
      '</ul>'
    )
  }

  let productsPromise = null
  function loadProducts(root) {
    if (productsPromise) return productsPromise
    const cached = readCache(root)
    if (cached) return (productsPromise = Promise.resolve(cached))

    productsPromise = Promise.all(
      PRODUCT_CODES.map((code) =>
        fetchCards(tagUrl(root, code)).then((r) => ({
          styles: r.styles,
          card: pickCard(r.cards, code),
        }))
      )
    )
      .then((results) => {
        const styles = results.flatMap((r) => r.styles)
        const seen = new Set()
        const cards = results
          .map((r) => r.card)
          .filter((li) => li && !seen.has(li.dataset.handle) && seen.add(li.dataset.handle))
        if (cards.length) return { styles, cards }
        // თეგებით ვერაფერი — კოლექციიდან
        return fetchCards(collectionUrl(root))
      })
      .then(({ styles, cards }) => {
        const html = buildHtml(styles, cards.slice(0, PRODUCTS_LIMIT))
        if (html) writeCache(root, html)
        return html || null
      })
      .catch(() => {
        productsPromise = null
        return null
      })
    return productsPromise
  }

  function renderProducts(panel, html) {
    const wrap = panel.querySelector('.dkhl-hs-panel__products-wrap')
    const list = panel.querySelector('.dkhl-hs-panel__products')
    const tmp = document.createElement('div')
    tmp.innerHTML = html || ''
    if (!tmp.querySelector('.dkhl-hs-card')) {
      wrap.hidden = true
      return
    }
    list.innerHTML = tmp.innerHTML
    markSingleSwatches(list)
    panel.dataset.loaded = '1'
    initSwatches() // თემის ფერის swatch-ები (როგორც predictive search-ში)
  }

  /* ================= ცოცხალი ძებნა =================
     Shopify-ს ჩვეულებრივი ძებნა (/search) + ჩვენი სექცია → თემის ბარათები.
     მიმდინარე ენაზე მუშაობს (KA → /search, EN → /en/search), ამიტომ
     ქართულადაც ეძებს და /en/-ზე არასდროს გადაგიყვანს. */

  const liveCache = new Map()
  const liveState = new WeakMap()

  const liveKey = (root, q) => root + '|' + q.toLowerCase()

  const liveUrl = (root, q) =>
    `${root}search?q=${encodeURIComponent(q)}&type=product` +
    `&options%5Bprefix%5D=last&section_id=${PRODUCTS_SECTION}`

  function fetchLive(root, q) {
    const key = liveKey(root, q)
    if (liveCache.has(key)) return Promise.resolve(liveCache.get(key))
    const ctrl = new AbortController()
    const promise = fetch(liveUrl(root, q), { signal: ctrl.signal })
      .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html')
        const el = doc.getElementById(`shopify-section-${PRODUCTS_SECTION}`) || doc.body
        const list = el.querySelector('ul.dkhl-hs-products')
        const result = {
          styles: Array.from(el.querySelectorAll('link[rel="stylesheet"]')).map((l) => l.outerHTML),
          cards: Array.from(el.querySelectorAll('li.dkhl-hs-card')).map((li) => li.outerHTML),
          count: parseInt((list && list.dataset.count) || '0', 10) || 0,
        }
        liveCache.set(key, result)
        return result
      })
    promise.abort = () => ctrl.abort()
    return promise
  }

  function liveSearch(header, immediate = false) {
    if (!header) return
    const panel = header.querySelector('.dkhl-hs-panel')
    const input = header.querySelector('.dkhl-hs-box__input')
    if (!panel || !input) return
    const st = liveState.get(panel) || {}
    liveState.set(panel, st)

    // X ტელეფონზე მხოლოდ მაშინ ჩანს, როცა რამე წერია
    if (input.form) input.form.classList.toggle('has-value', input.value.length > 0)

    const q = input.value.trim()
    clearTimeout(st.timer)

    // ცარიელი / ძალიან მოკლე → ისევ თეგები და პოპულარული პროდუქტები
    if (Array.from(q).length < LIVE_MIN_CHARS) {
      if (st.req && st.req.abort) st.req.abort()
      st.req = null
      st.query = ''
      // შედეგებიდან დაბრუნება → თეგები და პროდუქტები მაშინვე, სწრაფი ტალღით
      // (და არა გახსნის ~1.2 წამიანი დაყოვნებით)
      if (panel.classList.contains('is-searching')) panel.classList.add('is-back')
      panel.classList.remove('is-searching', 'is-loading')
      return
    }

    stopTyping(header)
    input.placeholder = TEXT.placeholder
    panel.classList.add('is-searching')
    // იგივე სიტყვა და შედეგები უკვე ჩანს → არაფერი
    if (q === st.query && !panel.classList.contains('is-loading')) return

    // უკვე ნაპოვნია → მაშინვე, skeleton-ის და ლოდინის გარეშე
    const cached = liveCache.get(liveKey(panel.dataset.root, q))
    if (cached) {
      if (st.req && st.req.abort) st.req.abort()
      st.req = null
      st.query = q
      renderLive(panel, q, cached)
      return
    }

    // ახალი სიტყვა → პრემიუმ skeleton მაშინვე, მოთხოვნა — წერის დასრულებისას
    showSkeleton(panel)

    const run = () => {
      if (st.req && st.req.abort) st.req.abort()
      st.query = q
      const req = fetchLive(panel.dataset.root, q)
      st.req = req
      req
        .then((res) => {
          if (st.req !== req) return // უკვე სხვა სიტყვას ვეძებთ
          renderLive(panel, q, res)
        })
        .catch((err) => {
          if (err && err.name === 'AbortError') return
          if (st.req !== req) return
          st.query = ''
          renderLive(panel, q, { styles: [], cards: [], count: 0 })
        })
    }
    if (immediate) run()
    else st.timer = setTimeout(run, LIVE_DEBOUNCE)
  }

  // ტელეფონი/ტაბლეტი: X ასუფთავებს ინფუთს → ისევ თეგები და პროდუქტები
  function clearInput(header) {
    const input = header.querySelector('.dkhl-hs-box__input')
    if (!input) return
    input.value = ''
    liveSearch(header)
    try {
      input.focus({ preventScroll: true })
    } catch (e) {
      input.focus()
    }
  }

  // skeleton ზუსტად ბარათის ფორმისაა: ფოტო → ტიპი → სახელი (2 ხაზი) → ფასი → swatch-ები
  function skeletonHtml(n) {
    return (
      '<div class="dkhl-hs-skeleton" aria-hidden="true">' +
      Array.from({ length: n }, (_, i) => `
        <div class="dkhl-hs-card dkhl-hs-card--skeleton" style="--dkhl-k:${i}">
          <span class="dkhl-hs-skel dkhl-hs-skel--media"></span>
          <span class="dkhl-hs-skel dkhl-hs-skel--type"></span>
          <span class="dkhl-hs-skel dkhl-hs-skel--title"></span>
          <span class="dkhl-hs-skel dkhl-hs-skel--title dkhl-hs-skel--title-2"></span>
          <span class="dkhl-hs-skel dkhl-hs-skel--price"></span>
          <span class="dkhl-hs-skel-swatches">
            <span class="dkhl-hs-skel dkhl-hs-skel--swatch"></span>
            <span class="dkhl-hs-skel dkhl-hs-skel--swatch"></span>
          </span>
        </div>`).join('') +
      '</div>'
    )
  }

  function showSkeleton(panel) {
    const grid = panel.querySelector('.dkhl-hs-results__grid')
    const all = panel.querySelector('.dkhl-hs-results__all')
    const empty = panel.querySelector('.dkhl-hs-results__empty')
    if (!panel.classList.contains('is-loading') || !grid.querySelector('.dkhl-hs-skeleton')) {
      grid.innerHTML = skeletonHtml(isDesktop() ? LIVE_LIMIT_DESKTOP : LIVE_LIMIT_MOBILE)
    }
    empty.hidden = true
    all.hidden = true
    panel.classList.add('is-loading')
  }

  // თუ პროდუქტს მხოლოდ 1 ვარიანტი (1 swatch) აქვს — swatch-ები იმალება
  function markSingleSwatches(root) {
    root.querySelectorAll('li.dkhl-hs-card').forEach((card) => {
      const count = card.querySelectorAll('.color-swatch').length
      card.classList.toggle('dkhl-hs-card--single', count <= 1)
    })
  }

  // თემის swatch-ების ინიციალიზაცია — ანიმაციის კადრებს რომ არ "შეეჯახოს"
  function initSwatches() {
    const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 120))
    idle(
      () => {
        try {
          if (typeof colorSwatches === 'function') colorSwatches()
        } catch (e) {}
      },
      { timeout: 500 }
    )
  }

  function renderLive(panel, q, res) {
    const grid = panel.querySelector('.dkhl-hs-results__grid')
    const empty = panel.querySelector('.dkhl-hs-results__empty')
    const all = panel.querySelector('.dkhl-hs-results__all')
    const limit = isDesktop() ? LIVE_LIMIT_DESKTOP : LIVE_LIMIT_MOBILE
    const cards = res.cards.slice(0, limit)

    panel.classList.remove('is-loading')

    if (!cards.length) {
      grid.innerHTML = ''
      empty.querySelector('.dkhl-hs-results__empty-title').textContent = TEXT.empty(q)
      empty.hidden = false
      all.hidden = true
      return
    }

    empty.hidden = true
    const css = Array.from(new Set(res.styles)).join('')
    grid.innerHTML =
      css +
      '<ul class="predictive-search__results-list predictive-search__results-list_products list-unstyled active dkhl-hs-products" role="list">' +
      cards.join('') +
      '</ul>'
    grid.querySelectorAll('li.dkhl-hs-card').forEach((li, i) => {
      li.style.setProperty('--dkhl-k', i)
      li.classList.add('dkhl-hs-card--live')
    })
    markSingleSwatches(grid)

    const total = Math.max(res.count, res.cards.length)
    all.querySelector('.dkhl-hs-results__all-text').textContent =
      total > 0 ? `${TEXT.all} (${total})` : TEXT.all
    all.hidden = false

    const body = panel.querySelector('.dkhl-hs-panel__body')
    if (body && !isDesktop()) body.scrollTop = 0

    initSwatches()
  }

  function openPanel(header) {
    const panel = header.querySelector('.dkhl-hs-panel')
    if (!panel) return
    panel.removeAttribute('aria-hidden')
    panel.classList.remove('is-back') // ყოველი გახსნა — სრული ანიმაციით
    panel.style.setProperty('--dkhl-base', `${cardsDelay()}s`)
    if (panel.dataset.loaded) return

    const openedAt = performance.now()
    loadProducts(panel.dataset.root).then((html) => {
      if (panel.dataset.loaded) return
      // თუ პასუხი გვიან მოვიდა — ბარათები დაუყოვნებლივ, მაგრამ ისევ სათითაოდ
      const elapsed = (performance.now() - openedAt) / 1000
      panel.style.setProperty('--dkhl-base', `${Math.max(0, cardsDelay() - elapsed)}s`)
      renderProducts(panel, html)
    })
  }

  /* ფონის ჩაბნელება + ბლარი — ზუსტად მეგა მენიუს მსგავსად */
  function getOverlay() {
    let overlay = document.querySelector('.dkhl-hs-overlay')
    if (!overlay) {
      overlay = document.createElement('div')
      overlay.className = 'dkhl-hs-overlay'
      document.body.appendChild(overlay)
    }
    return overlay
  }

  /* ================= გახსნა / დახურვა ================= */

  const searchButtons = (header) => header.querySelectorAll(BTN_SEL)

  function open(header) {
    const form = header.querySelector('.dkhl-hs-box')
    const tile = form.querySelector('.dkhl-hs-box__submit')
    const input = form.querySelector('input')

    // ღილაკს ანიმაციის გარეშე ვსვამთ "ძებნა"-ს აიქონზე, მერე ვიწყებთ
    header.classList.add('dkhl-hs-noanim')
    measure(header)
    void getComputedStyle(tile).transform
    header.classList.remove('dkhl-hs-noanim')
    void getComputedStyle(tile).transform

    // თუ მეგა მენიუ ღიაა — ვხურავთ (მისი Escape-ის ლოგიკით)
    if (document.querySelector('.dkhl-mega-open')) {
      document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape' }))
    }

    header.classList.add(OPEN)
    getOverlay().classList.add('dkhl-hs-overlay--visible')

    form.querySelectorAll('input, button').forEach((el) => (el.tabIndex = 0))
    form.classList.toggle('has-value', input.value.length > 0)
    startTyping(header, input)
    openPanel(header)
    if (input.value.trim()) liveSearch(header, true)

    if (isDesktop()) {
      setTimeout(() => {
        if (header.classList.contains(OPEN)) input.focus({ preventScroll: true })
      }, 320)
    } else {
      // ტელეფონზე კლავიატურა მხოლოდ დაჭერის მომენტში იხსნება → მაშინვე
      document.documentElement.classList.add('dkhl-hs-noscroll')
      try {
        input.focus({ preventScroll: true })
      } catch (e) {
        input.focus()
      }
    }
  }

  function close(header, returnFocus = false) {
    if (!header || !header.classList.contains(OPEN)) return
    header.classList.remove(OPEN)
    stopTyping(header)
    document.documentElement.classList.remove('dkhl-hs-noscroll')
    const panel = header.querySelector('.dkhl-hs-panel')
    if (panel) panel.setAttribute('aria-hidden', 'true')
    getOverlay().classList.remove('dkhl-hs-overlay--visible')

    const form = header.querySelector('.dkhl-hs-box')
    if (form) {
      form.querySelectorAll('input, button').forEach((el) => (el.tabIndex = -1))
      form.querySelector('input').blur()
    }

    if (returnFocus) {
      const btn = Array.from(searchButtons(header)).find(
        (b) => !inDrawer(b) && isVisible(b)
      )
      if (btn) btn.focus({ preventScroll: true })
    }
  }

  /* ================= მოვლენები ================= */

  // capture — თემის ძველ ჩამოსაშლელამდე ვიჭერთ დაჭერას
  window.addEventListener(
    'click',
    (e) => {
      const header = getHeader()
      if (!header) return

      const btn = e.target.closest(BTN_SEL)
      if (btn && header.contains(btn) && !inDrawer(btn)) {
        if (!setup(header)) return // ვერ მომზადდა → თემის ძველი ძებნა
        e.preventDefault()
        e.stopImmediatePropagation()
        header.classList.contains(OPEN) ? close(header) : open(header)
        return
      }

      // გარეთ დაჭერა ხურავს
      if (header.classList.contains(OPEN) && !e.target.closest('.dkhl-hs-box, .dkhl-hs-panel')) {
        close(header)
      }
    },
    true
  )

  // მაუსის მიტანისას / თითის დადებისას პროდუქტებს წინასწარ ვტვირთავთ
  const prefetch = (e) => {
    if (productsPromise) return
    if (!e.target.closest || !e.target.closest(BTN_SEL)) return
    const panel = document.querySelector('.dkhl-hs-panel')
    if (panel && !panel.dataset.loaded) loadProducts(panel.dataset.root)
  }
  document.addEventListener('pointerover', prefetch, { passive: true })
  document.addEventListener('pointerdown', prefetch, { passive: true })

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return
    const header = getHeader()
    if (header && header.classList.contains(OPEN)) close(header, true)
  })

  window.addEventListener('resize', () => {
    const header = getHeader()
    if (header && header.classList.contains(OPEN)) measure(header)
  })

  // ტელეფონის კლავიატურა ხილულ ეკრანს ამცირებს → პანელის სიმაღლე ვასწორებთ
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', () => {
      const header = getHeader()
      if (header && header.classList.contains(OPEN)) measurePanel(header)
    })
  }

  // დესკტოპ ↔ ტელეფონის ზღვარზე გადასვლისას (მაგ. ეკრანის შემობრუნება) ვხურავთ
  const onBreakpoint = () => {
    const header = getHeader()
    close(header)
    if (header) placeForm(header)
  }
  DESKTOP.addEventListener
    ? DESKTOP.addEventListener('change', onBreakpoint)
    : DESKTOP.addListener(onBreakpoint)

  const init = () => setup(getHeader())
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }
  // თემის რედაქტორში სექციის გადატვირთვისას
  document.addEventListener('shopify:section:load', init)

  // "უკან" ღილაკით დაბრუნებისას ძებნა დახურული დახვდეს
  window.addEventListener('pageshow', (e) => {
    if (!e.persisted) return
    const header = getHeader()
    if (header && header.classList.contains(OPEN)) close(header)
    document.documentElement.classList.remove('dkhl-hs-noscroll')
  })
})()


window.__dkhlSearchReady = true;

if (window.__dkhlSearchQueued) {
  window.__dkhlSearchQueued = false;
  openSearch(); // ← შენი ფუნქცია, რომელიც ახალ სერჩს ხსნის
}